export class StorageKey {
  static readonly medicinesToCompare = '__MEDICINES_TO_COMPARE';
  static readonly anamnesResponse = '__ANAMNES_RESPONSE';
  static readonly language = '__LANGUAGE';
  static readonly theme = '__THEME';
}

export const useLocalStorage = () => {
  const setLocalStorage = (key: string, value: string | null) => {
    if (value === null) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, value);
    }
  };

  const getLocalStorage = (key: string): string | null => {
    return localStorage.getItem(key);
  };

  return { setLocalStorage, getLocalStorage };
};
